(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sav-product"]) return;
  try {
    
  if (!customElements.get('sav-product')) {
    customElements.define('sav-product', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.addEventListener('submit', event => {
          if (!this.privateReviewActive()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
        }, true);
        this.variantSelect = this.querySelector('select[name="id"]');
        this.variantSelect?.addEventListener('change', () => this.updateVariant());
        this.syncScentContent();
        this.querySelectorAll('[data-sav-gallery-src]').forEach(link => {
          link.addEventListener('click', event => {
            const image = this.querySelector('.gal > img.main');
            if (!image) return;
            const variantId = link.dataset.savGalleryVariant;
            if (variantId && this.variantSelect && !this.selectVariant(variantId)) return;
            event.preventDefault();
            this.updateImage(link.dataset.savGallerySrc, link.dataset.savGallerySrcset, link.dataset.savGalleryCaption);
          });
        });
      }
      selectVariant(variantId) {
        const option = Array.from(this.variantSelect?.options || []).find(item => item.value === variantId);
        if (!option) return false;
        this.variantSelect.value = option.value;
        this.updateVariant();
        return true;
      }
      privateReviewActive() {
        return this.dataset?.savPrivateReview === 'true' || window.SAV_SHOPIFY?.privateDesignReview === true;
      }
      syncScentContent() {
        const scent = this.querySelector('[data-sav-scent-content] [data-sav-scent-key]');
        if (!scent) return;
        const key = scent.dataset.savScentKey || '';
        if (scent.dataset.savScentHue) this.style.setProperty('--sc-light', scent.dataset.savScentHue);
        if (scent.dataset.savScentDarkHue) this.style.setProperty('--sc-dark', scent.dataset.savScentDarkHue);
        const pairMembers = { a: ['hedge', 'deep'], b: ['after', 'silent'] };
        if (window.SAV_SHOPIFY) window.SAV_SHOPIFY.currentScent = ['silent', 'hedge', 'after', 'deep', 'a', 'b'].includes(key) ? key : '';
        this.querySelectorAll('[data-sav-format-link]').forEach(link => {
          let variants;
          try { variants = JSON.parse(link.dataset.savFormatVariants || '[]'); }
          catch { return; }
          if (!Array.isArray(variants)) return;
          const pairTarget = variants.some(item => Object.hasOwn(pairMembers, item.scent));
          const destinationKey = pairTarget && !Object.hasOwn(pairMembers, key)
            ? Object.keys(pairMembers).find(pair => pairMembers[pair].includes(key))
            : key;
          const variant = variants.find(item => item.scent === destinationKey);
          if (!variant && variants.some(item => /^\d+$/.test(String(item.id)))) {
            const url = new URL(link.dataset.savFormatBase, window.location.origin);
            url.searchParams.delete('variant');
            link.href = url.href;
            const price = link.querySelector('[data-sav-format-price]');
            const stock = link.querySelector('[data-sav-format-stock]');
            if (price) price.textContent = '選擇香氣 / Choose scent';
            if (stock) stock.hidden = true;
            return;
          }
          if (!variant || !/^\d+$/.test(String(variant.id))) return;
          const url = new URL(link.dataset.savFormatBase, window.location.origin);
          url.searchParams.set('variant', String(variant.id));
          link.href = url.href;
          const price = link.querySelector('[data-sav-format-price]');
          const stock = link.querySelector('[data-sav-format-stock]');
          if (price) price.textContent = variant.price;
          if (stock) { stock.textContent = link.dataset.savSoldoutText || ''; stock.hidden = variant.available === true; }
        });
      }
      updateScent(variantId) {
        const target = this.querySelector('[data-sav-scent-content]');
        const template = Array.from(this.querySelectorAll('template[data-sav-scent-template]')).find(node => node.dataset.savScentTemplate === variantId);
        if (!target || !template) return;
        target.replaceChildren(template.content.cloneNode(true));
        this.syncScentContent();
      }
      updateImage(src, srcset, alt) {
        const image = this.querySelector('.gal > img.main');
        if (!image || !src) return;
        image.src = src;
        if (srcset) image.srcset = srcset;
        else image.removeAttribute('srcset');
        image.alt = alt || '';
        this.querySelectorAll('[data-sav-gallery-src]').forEach(link => {
          if (link.dataset.savGallerySrc === src) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      }
      updateVariant() {
        const option = this.variantSelect?.selectedOptions[0];
        if (!option) return;
        const price = this.querySelector('[data-sav-price]');
        const compare = this.querySelector('[data-sav-compare]');
        const button = this.querySelector('[data-sav-add]');
        if (price) price.textContent = option.dataset.price || '';
        if (compare) {
          compare.textContent = option.dataset.compare || '';
          compare.hidden = option.dataset.hasCompare !== 'true';
        }
        if (button) {
          const available = option.dataset.available === 'true';
          const privateReview = this.privateReviewActive();
          button.disabled = privateReview || !available;
          button.textContent = privateReview ? button.dataset.reviewText : available ? button.dataset.availableText : button.dataset.soldoutText;
        }
        this.updateScent(option.value);
        this.updateImage(option.dataset.image, option.dataset.imageSrcset, option.dataset.imageAlt);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState(window.history.state, '', url);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
